import { useCallback } from 'react';

function sameDeviceId(device, socketDeviceId) {
  if (!device || !socketDeviceId) {
    return false;
  }
  const id = device.deviceId || device._id;
  return id != null && String(id) === String(socketDeviceId);
}

/**
 * Merge socket device_status payload into a device row (coords + RAG cache fields).
 */
export function mergeDeviceStatusFromSocket(device, data) {
  if (!device || !data) {
    return device;
  }

  const socketDeviceId = data.device_id || data.deviceId;
  if (socketDeviceId && !sameDeviceId(device, socketDeviceId)) {
    return device;
  }

  const updates = {};

  if (data.latitude !== undefined && data.longitude !== undefined) {
    updates.latitude = data.latitude;
    updates.longitude = data.longitude;
  }

  if (data.ragStatus !== undefined) {
    updates.ragStatus = data.ragStatus;
  }
  if (data.status !== undefined) {
    updates.status = data.status;
  }
  if (data.lastSeenAt !== undefined) {
    updates.lastSeenAt = data.lastSeenAt;
  }
  if (data.lastEventType !== undefined) {
    updates.lastEventType = data.lastEventType;
  }
  if (data.batteryLevel !== undefined) {
    updates.batteryLevel = data.batteryLevel;
  }
  if (data.lock_status !== undefined) {
    updates.lock_status = data.lock_status;
  }
  if (data.eventType !== undefined) {
    updates.eventType = data.eventType;
  }

  if (Object.keys(updates).length === 0) {
    return device;
  }

  return { ...device, ...updates };
}

/** Merge socket payload into an array of device rows; returns same ref if unchanged. */
export function mergeSocketIntoDeviceArray(prev, payload) {
  const socketDeviceId = payload?.device_id || payload?.deviceId;
  if (!prev?.length || !socketDeviceId) {
    return prev;
  }

  let changed = false;
  const next = prev.map((device) => {
    if (!sameDeviceId(device, socketDeviceId)) {
      return device;
    }
    const merged = mergeDeviceStatusFromSocket(device, payload);
    if (merged !== device) {
      changed = true;
    }
    return merged;
  });

  return changed ? next : prev;
}

/**
 * Returns a socket callback that updates a devices list state by deviceId.
 */
export function useDeviceStatusSocketUpdater(setDevicesList) {
  return useCallback(
    (payload) => {
      setDevicesList((prev) => mergeSocketIntoDeviceArray(prev, payload));
    },
    [setDevicesList],
  );
}
